import css from './styles/your-accounts-table.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { getLoadingCadenceAccounts } from '../../redux/actions/appActions';
import { Spinner } from 'shamrock-clover-ui/dist/clover/components/Spinner/Spinner';
import ClientMenuItem from './client-menu-item';
import { ClientSuggestion } from '../../interfaces/clients';
import FirebaseAnalytics from '../core/analytics';

type AccountTableProps = {
  addedAccounts: ClientSuggestion[];
  accountsToRemove: ClientSuggestion[];
  currentAccounts: ClientSuggestion[];
  setAddedAccounts: Function;
  setAccountsToRemove: Function;
};

const YourAccountsTable: React.FC<AccountTableProps> = ({
  addedAccounts = [],
  accountsToRemove = [],
  currentAccounts = [],
  setAddedAccounts,
  setAccountsToRemove,
}) => {
  const loadingAccounts = useSelector(getLoadingCadenceAccounts);
  const stagedCount = addedAccounts.length + currentAccounts.length - accountsToRemove.length;
  const headerSection = () => (
    <div className={css.headerContainer}>
      <div className={css.spacerDiv} />
      <div className={css.clientNumberDiv}>CLIENT #</div>
      <div className={css.clientNameDiv}>CLIENT NAME</div>
      <div className={css.clientMCNumberDiv}>MC #</div>
      <div className={css.deleteButtonSpacerDiv} />
    </div>
  );

  const removeAddedAccount = (removedAccount) => {
    FirebaseAnalytics.sendEvent(
      FirebaseAnalytics.EVENTS.CLICK,
      FirebaseAnalytics.MODULES.FACTORING,
      FirebaseAnalytics.PAGES.ADD_REMOVE_ACCOUNTS,
      {
        type: 'remove',
      },
    );
    setAddedAccounts(addedAccounts.filter((account) => account.client_number !== removedAccount.client_number));
  };

  const toggleExistingAccountForRemoval = (removedAccount) => {
    const removalIndex = accountsToRemove.findIndex((acct) => removedAccount.client_number === acct.client_number);
    if (removalIndex > -1) {
      setAccountsToRemove(accountsToRemove.filter((item) => item.client_number !== removedAccount.client_number));
    } else {
      FirebaseAnalytics.sendEvent(
        FirebaseAnalytics.EVENTS.CLICK,
        FirebaseAnalytics.MODULES.FACTORING,
        FirebaseAnalytics.PAGES.ADD_REMOVE_ACCOUNTS,
        {
          type: 'remove',
        },
      );
      setAccountsToRemove([...accountsToRemove, removedAccount]);
    }
  };

  return (
    <>
      <div className={css.yourAccountsSubHeading}>Your Accounts{` - ${stagedCount}`}</div>
      {headerSection()}
      <div className={css.scrollAccountsOuterDiv}>
        {loadingAccounts ? (
          <div className={css.spinnerDiv}>
            <Spinner /> <span style={{ fontSize: '14px' }}>Loading accounts...</span>
          </div>
        ) : addedAccounts.length + currentAccounts.length == 0 ? (
          <div style={{ fontSize: '14px', padding: '15px' }}>No accounts added</div>
        ) : (
          <>
            <div className={css.addedAccountsDiv}>
              {addedAccounts.map((client) => (
                <ClientMenuItem
                  key={client.client_number}
                  isNew={true}
                  client={client}
                  removeButtonAction={removeAddedAccount}
                />
              ))}
            </div>
            <div className={css.currentAccountsDiv}>
              {currentAccounts.map((client) => (
                <ClientMenuItem
                  key={client.client_number}
                  client={client}
                  isBeingRemoved={
                    accountsToRemove.findIndex((acct) => client.client_number === acct.client_number) > -1
                  }
                  removeButtonAction={toggleExistingAccountForRemoval}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default YourAccountsTable;
